import React from 'react';
const Contacto = () => {
  return <>Contacto</>;
};
export default Contacto;
